import { Route } from '@angular/router';
import { EcouponFormToyoComponent } from './ecoupon-form-toyo/ecoupon-form-toyo.component';
import { EcouponOtpComponent } from './ecoupon-otp/ecoupon-otp.component';
import { EcouponInformationComponent } from './ecoupon-information/ecoupon-information.component';
import { ecouponOTPGuard } from './ecoupon-otp/ecoupon-otp.guard';
import { LoadingComponent } from './loading/loading.component';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'e-coupon/campaign/:id',
    pathMatch: 'full',
    title: 'TOYO Discount Code',
  },
  {
    path: 'e-coupon/campaign/:id',
    component: LoadingComponent,
  },
  {
    path: 'e-coupon/campaign/form/:id',
    component: EcouponFormToyoComponent,
  },
  {
    path: 'e-coupon/otp',
    component: EcouponOtpComponent,
    canActivate: [ecouponOTPGuard],
  },
  {
    path: 'e-coupon/information',
    component: EcouponInformationComponent,
  },
];
